import { register, find } from '../../../Javascript/Utils.js'
import { Luminous } from 'luminous-lightbox'

const ImageZoom = el => {
  const caption = el.dataset.caption || false
  const lightBoxLink = find('a', el)
  const luminousOpts = {
    namespace: 'mImageZoom',
    caption
  }

  function makeLuminous () {
    return new Luminous(lightBoxLink, luminousOpts)
  }
  makeLuminous()
}

register('ImageZoom', ImageZoom)
